import React from 'react';
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { MenuLinks } from './MenuLinks';
import MenuLinksCa from './MenuLinksCa';

export default class MobileNav extends React.Component {
  constructor(props) {
    super(props);
    this.container = document.getElementById(props.container_id);
    this.state = {
      ...props,
      show: false,
    };
  }

  toggleLeftNav = () => {
    this.setState({ show: !this.state.show });
  };

  render() {
    const { country, platinumEcomBaseUrl } = this.props;

    if (country === 'Canada') {
      return (
        <React.Fragment>
          <span onClick={this.toggleLeftNav}>
            <FontAwesomeIcon
              icon={faBars}
              style={{ marginLeft: '4px', display: 'inline-block' }}
            />
          </span>
          {ReactDOM.createPortal(
            <MenuLinksCa
              show={this.state.show}
              platinumEcomBaseUrl={platinumEcomBaseUrl}
            />,
            this.container
          )}
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <span onClick={this.toggleLeftNav}>
          <FontAwesomeIcon
            icon={faBars}
            style={{ marginLeft: '4px', display: 'inline-block' }}
          />
        </span>
        {ReactDOM.createPortal(
          <MenuLinks
            show={this.state.show}
            platinumEcomBaseUrl={platinumEcomBaseUrl}
          />,
          this.container
        )}
      </React.Fragment>
    );
  }
}
